/* eslint-disable max-len */
import React from 'react'

function OrderCancelledButton({OrderData}) {
    const {order} =OrderData;
    return (
        <>
            {order.status ==="8"  ?
                <button className="w-[100%] h-9 font-semibold bg-[#EDA3A6] text-sm text-[#6E1417] rounded-lg mt-[29px]" 
                    style={{border:'1px solid #6E1417',borderColor:'##6E1417',borderRadius:'8px'}}  data-bs-toggle="modal" data-bs-target="#RejectModal"
                >
                    <div className='flex items-center justify-center bg-[#EDA3A6]  px-18'>
                        <img src="/images/remove-cross.png" className='h-[13px] w-[13px]'/>
                        <span className='pl-[5px] font-semibold'>Order Cancelled</span>
                    </div> 
                </button>:null
            }</>
    )
}

export default OrderCancelledButton